export default "__VITE_ASSET__CML8w4JM__"